import React, { useState, useEffect } from 'react';
import { jsPDF } from 'jspdf'; 
import autoTable from 'jspdf-autotable'; 
import API from './api'; 

const QRReportView = () => {
    const [allData, setAllData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [dateRange, setDateRange] = useState({ start: '', end: '' });
    const [filters, setFilters] = useState({
        company: 'All',
        product: 'All',
        brand: 'All'
    });

 useEffect(() => {
    const fetchAllQRs = async () => {
        try {
            setIsLoading(true);
            
            const response = await API.get('/qr/get-all-generated-qrs');
            const data = response.data;
            
            console.log("Full Data from Backend:", data);
            
            if (response.status === 200) {
                setAllData(data);
            }
        } catch (err) {
            console.error("Fetch error:", err);
            if (err.response?.status === 401) {
                console.error("Unauthorized access to QR reports!");
            }
        } finally {
            setIsLoading(false);
        }
    };
    
    fetchAllQRs();
}, []);

    const filteredQRs = allData.filter(qr => {
    const term = searchTerm.toLowerCase();
    const matchesSearch = 
        (qr.qrId || "").toLowerCase().includes(term) || 
        (qr.serialNumber || "").toLowerCase().includes(term) ||
        (qr.registrationId || "").toLowerCase().includes(term) ||
        (qr.company || "").toLowerCase().includes(term);

    const matchesCompany = filters.company === 'All' || qr.company === filters.company;
    const matchesProduct = filters.product === 'All' || qr.product === filters.product;
    const matchesBrand = filters.brand === 'All' || qr.brand === filters.brand;
    
    return matchesSearch && matchesCompany && matchesProduct && matchesBrand;
});

    // 3. PDF එක සාදන ලොජික් එක...............................................................
const exportPDF = () => {
        const doc = new jsPDF();
        let dataToExport = filteredQRs; 

        if (dateRange.start && dateRange.end) {
            dataToExport = filteredQRs.filter(qr => {
                const qrDate = new Date(qr.mfd);
                const startDate = new Date(dateRange.start);
                const endDate = new Date(dateRange.end);
                
                endDate.setHours(23, 59, 59, 999);

                return qrDate >= startDate && qrDate <= endDate;
            });
        }

        if (dataToExport.length === 0) {
            alert("No records found for the selected date range!");
            return;
        }
        
        // Header විස්තර
        doc.setFontSize(16);
        doc.setTextColor(46, 204, 113);
        doc.text("EPR System - Master QR Audit Report", 14, 15);
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 22);
        if (dateRange.start && dateRange.end) {
            doc.text(`Period: ${dateRange.start} to ${dateRange.end} | Records: ${dataToExport.length}`, 14, 27);
        } else {
            doc.text(`Total Records Found: ${dataToExport.length}`, 14, 27);
        }

        const tableColumn = ["QR ID", "Reg ID", "Company", "Product", "Brand", "MFD"];
        
        // PDF එකට සර්ච් වුණු ඔක්කොම දත්ත (slice කරන්නේ නැතුව) ගන්නවා
        const tableRows = filteredQRs.map(qr => [
            qr.qrId,
            qr.registrationId || 'N/A',
            qr.company,
            qr.product,
            qr.brand,
            qr.mfd
        ]);

        // autoTable(doc, ...) ලෙස පාවිච්චි කිරීමෙන් TypeError එක නැති වේ
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 35,
            theme: 'grid',
            headStyles: { 
                fillColor: [46, 204, 113], 
                fontSize: 10,
                halign: 'center'
            },
            styles: { 
                fontSize: 8,
                cellPadding: 3 
            },
            didDrawPage: (data) => {
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(9);
                doc.setTextColor(150);
                
                // පිටුවේ පල්ලෙහා දකුණු කෙළවරේ පිටු අංකය පෙන්වීම
                const pageSize = doc.internal.pageSize;
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                
                doc.text(`Page ${pageCount}`, pageWidth - 25, pageHeight - 10);
            },
            columnStyles: {
                0: { cellWidth: 40 }, 
                1: { fontStyle: 'bold' } 
            }
        });

        doc.save(`Master_QR_Report_${new Date().getTime()}.pdf`);
    };

    if (isLoading) {
        return <div style={{ color: '#2ecc71', textAlign: 'center', padding: '50px' }}>Loading Master QR Records...</div>;
    }

    return (
       <div style={reportStyles.container}>
    <div style={reportStyles.header}>
        <div>
            {/* ප්‍රධාන මාතෘකාව */}
            <h3 style={{ color: '#2ecc71', margin: 0 }}>Master QR Audit Log</h3>
            
            {/* 📊 මෙන්න මෙතන තමයි අලුත් Count ලොජික් එක තියෙන්නේ */}
            <div style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
                Total Records: <span style={{ color: '#fff' }}>{allData.length}</span> | 
                Filtered Results: <span style={{ color: '#2ecc71', fontWeight: 'bold' }}>{filteredQRs.length}</span>
            </div>
        </div>
{/* PDF Export Section - දැන් මෙතන තමයි Date Selection එක තියෙන්නේ */}
    <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
        <div style={reportStyles.pdfDateWrapper}>
            <span style={{ fontSize: '11px', color: '#888', marginRight: '5px' }}>Export Period:</span>
            <input 
                type="date" 
                style={reportStyles.pdfDateInput}
                onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })} 
            />
            <span style={{ color: '#444' }}>-</span>
            <input 
                type="date" 
                style={reportStyles.pdfDateInput}
                onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })} 
            />
        </div>
        {/* PDF Export බටන් එක */}
        <button onClick={exportPDF} style={reportStyles.pdfBtn}>Export PDF Report</button>
    </div>
 </div>
            {/* ෆිල්ටර් කොටස */}
          <div style={reportStyles.filterGrid}>
    <input 
        placeholder="🔍 Search QR ID, Company or Reg No..."
        style={reportStyles.input} 
        onChange={(e) => setSearchTerm(e.target.value)} 
    />
    
    {/* Company Filter */}
    <select 
        style={{ ...reportStyles.input, backgroundColor: '#1a1a1a', color: '#fff' }} 
        onChange={(e) => setFilters({...filters, company: e.target.value})}
    >
        <option value="All" style={{ background: '#1a1a1a', color: '#fff' }}>All Companies</option>
        {[...new Set(allData.map(q => q.company))].map(c => (
            <option key={c} value={c} style={{ background: '#1a1a1a', color: '#fff' }}>{c}</option>
        ))}
    </select>

    {/* Product Filter */}
    <select 
        style={{ ...reportStyles.input, backgroundColor: '#1a1a1a', color: '#fff' }} 
        onChange={(e) => setFilters({...filters, product: e.target.value})}
    >
        <option value="All" style={{ background: '#1a1a1a', color: '#fff' }}>All Products</option>
        {[...new Set(allData.map(q => q.product))].map(p => (
            <option key={p} value={p} style={{ background: '#1a1a1a', color: '#fff' }}>{p}</option>
        ))}
    </select>

    {/* Brand Filter */}
    <select 
        style={{ ...reportStyles.input, backgroundColor: '#1a1a1a', color: '#fff' }} 
        onChange={(e) => setFilters({...filters, brand: e.target.value})}
    >
        <option value="All" style={{ background: '#1a1a1a', color: '#fff' }}>All Brands</option>
        {[...new Set(allData.map(q => q.brand))].map(b => (
            <option key={b} value={b} style={{ background: '#1a1a1a', color: '#fff' }}>{b}</option>
        ))}
    </select>
</div>

            {/* ටේබල් කොටස */}
            <div style={reportStyles.tableWrapper}>
                <table style={reportStyles.table}>
                    <thead>
                        <tr style={reportStyles.tableHead}>
                            <th style={reportStyles.th}>QR ID</th>
                            <th style={reportStyles.th}>Company Details</th>
                            <th style={reportStyles.th}>Product & Brand</th>
                            <th style={reportStyles.th}>MFD Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredQRs.slice(0, 100).map((qr, idx) => ( 
                            <tr key={idx} style={reportStyles.tr}>
                                <td style={{ ...reportStyles.td, color: '#2ecc71', fontWeight: 'bold' }}>{qr.qrId}</td>
                               <td style={reportStyles.td}>
                <div style={{ color: '#fff', fontWeight: '600' }}>{qr.company}</div>
                <div style={{ fontSize: '11px', color: '#2ecc71', opacity: 0.8, marginTop: '4px' }}>
                    {qr.registrationId || 'REG-N/A'}
                           </div>
                             </td>
                                <td style={reportStyles.td}>
                                    <div style={{ color: '#ccc' }}>{qr.product}</div>
                                    <div style={{ fontSize: '12px', color: '#2ecc71' }}>{qr.brand}</div>
                                </td>
                                <td style={{ ...reportStyles.td, color: '#888' }}>{qr.mfd}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {filteredQRs.length > 100 && (
                    <p style={{ textAlign: 'center', color: '#555', marginTop: '10px' }}>
                        Showing first 100 records. Use filters to narrow down.
                    </p>
                )}
            </div>
        </div>
    );
};

const reportStyles = {
    container: { animation: 'fadeIn 0.5s' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' },
    pdfBtn: { background: '#3de467', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold' },
    filterGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginBottom: '25px' },
    input: { padding: '12px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' },
    tableWrapper: { background: 'rgba(0,0,0,0.2)', borderRadius: '15px', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    tableHead: { background: 'rgba(46, 204, 113, 0.1)', borderBottom: '2px solid #2ecc71' },
    th: { padding: '15px', textAlign: 'left', fontSize: '13px' },
    td: { padding: '15px', fontSize: '13px', borderBottom: '1px solid rgba(255,255,255,0.03)' },
    tr: { transition: '0.3s' }
};

export default QRReportView;